import "./AboutUsStyles.css";
import CertificateImages from './CertificateImages';

const AboutUs = () => {
  return (
    <div className="about-cointainer">
      <p>
        <strong>"Aurora"</strong> is a maritime crewing agency specializing in
        providing high-quality maritime services for commercial and passenger
        fleets, including yachts. Founded in 2019, our company is based in the
        beautiful countries of Portugal and Ukraine. We take pride in assembling
        a team of experienced professionals with a wealth of expertise in the
        maritime industry. At <strong>"Aurora"</strong> we understand the
        importance of safety, reliability, and efficiency in the maritime
        business. Our main goal is to ensure our clients receive excellent
        service and ensure the uninterrupted operation of their vessels. We
        recognize that each vessel has its unique requirements, so our team
        carefully tailors our services to meet the individual needs of each
        client. One of the key features of <strong>"Aurora"</strong> is our
        extensive database of experienced seafarers. We take pride in having
        access to a wide range of highly skilled professionals who can
        efficiently manage and service various types of vessels. Our team is
        constantly updated, enabling us to offer fresh and innovative solutions
        to our clients. We strive for continuous improvement and innovation,
        which is why at <strong>"Aurora"</strong>, we actively monitor the
        latest trends in the maritime industry and invest in the development of
        new technologies and approaches. We are confident that this allows us to
        stay ahead of the competition and provide our clients with the best
        solutions. If you are seeking a reliable and professional partner to
        service your commercial or passenger fleet, <strong>"Aurora"</strong> is
        ready to stand by your side. Our team will gladly assist you in
        achieving your goals and ensure the safety and efficiency of your
        vessel. Contact us today and discover how <strong>"Aurora"</strong> can
        become your trusted partner in the maritime industry. We are prepared to
        answer your questions, offer solutions, and provide detailed information
        about our services. Choose
        <strong>"Aurora"</strong> - your dependable companion in maritime
        adventures!
      </p>
      <CertificateImages />
    </div>
  );
}

export default AboutUs;